// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6851":"9fe0a141","7279":"eff926d1","7473":"f94803b4"}[chunkId] + ".chunk.css";
};